/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const costCalculatorAuthenticatedPostRequestSchema = z.object({
  buy_to_let: z.string(),
  deposit: z.string(),
  property_value: z.string(),
  term: z.string(),
});
